import Overlay from '../components/popup/overlay'

/**
 * Mixin for overlays
 */
export default {
  components: {
    overlay: Overlay,
  },
  created() {
    if (this.$router.currentRoute.query) {
      const popupName = this.$router.currentRoute.query.popup
      if (popupName) {
        this.overlay = popupName
      }
    }
  },

  data() {
    return {
      isInsertQuery: false,
      /**
       * Active overlay name
       */
      overlay: '',
    }
  },
  methods: {
    /**
     * Unset active overlay name
     */
    closeOverlay() {
      this.overlay = ''
      if (this.isInsertQuery) {
        this.$router.go(-1)
      }
    },

    /**
     * Set active overlay name
     * based on provided name
     * @param {string} overlay
     */
    showOverlay(overlay, isInsertQuery = false) {
      if (overlay) {
        this.overlay = overlay
        this.isInsertQuery = isInsertQuery

        if (isInsertQuery) {
          const currentRoute = this.$router.currentRoute
          this.$router.push({
            path: currentRoute.path,
            query: {
              ...currentRoute.query,
              popup: overlay,
            },
          })
        }
      }
    },
  },
}
